import UserNotProfilePic from '../../../assets/iconos/usuario.png';
import './Contactos.css';
import { acceptRequest, getFriendsList, deleteFriend, sendFriendRequest, pendingRequest, requiredRequest, usersForRequest } from '../../../Services/Inbox.js';
import { useState } from 'react';
import DialogModal from '../../Modals/dialogModal';

import useDebounce from '../../../Hooks/useDebounce';

const Contactos = () => {

    const [actualList, setActualList] = useState('contacts');
    const [onLoad, setOnLOad] = useState(true);

    const [friendListData, setFriendListData] = useState([]);
    const [friendListPaging, setFriendListPaging] = useState({ actual: 1 });
    const [isPrevPage, setIsPrevPage] = useState(false);
    const [isNextPage, setIsNextPage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showString, setShowString] = useState("");

    const loadFriendList = async (num = null, name = "", list = null) => {
        setOnLOad(true);

        var rsp;
        switch (list || actualList) {
            case 'contacts': {
                rsp = await getFriendsList({ page: num || friendListPaging.actual, name: name });
                break;
            };
            case 'add-contacts': {
                rsp = await usersForRequest({ page: num || friendListPaging.actual, name: name });
                break;
            };
            case 'friend-request-send': {
                rsp = await pendingRequest({ page: num || friendListPaging.actual, name: name });
                break;
            };
            case 'friend-request-received': {
                rsp = await requiredRequest({ page: num || friendListPaging.actual, name: name });
                break;
            }
        }

        if (rsp?.Error === false) {
            setFriendListData(rsp.Data.data);
            setFriendListPaging({ actual: rsp.Data.current_page, total: rsp.Data.last_page });
            setIsPrevPage(rsp.Data.prev_page_url != null);
            setIsNextPage(rsp.Data.next_page_url != null);
            setOnLOad(false);
        } else {
            setShowModal(true);
            setShowString("No se pudo cargar la lista de contactos.");
        }
    }

    const handlerDeleteFriend = async (id) => {
        let rsp = await deleteFriend(id);
        if (rsp.Error === false) {
            loadFriendList();
        } else {
            setShowModal(true);
            setShowString("En este momento no se pudo realizar la operacion.");
        }
    }

    const handlerSendFriendRequest = async (id) => {
        let rsp = await sendFriendRequest(id);
        if (rsp?.Error === false) {
            loadFriendList();
        } else {
            setShowModal(true);
            setShowString("En este momento no fue posible enviar la solicitud.");
        }
    }

    const handlerAcceptRequest = async (id) => {
        let rsp = await acceptRequest(id);
        if (rsp?.Error === false) {
            loadFriendList();
        } else {
            setShowModal(true);
            setShowString("En este momento no se pudo aceptar la solicitud.");
        }
    }

    const handlerPaginate = (num) => {
        setFriendListPaging({ actual: friendListPaging.actual + num });
        loadFriendList(friendListPaging.actual + num);
    }

    const debounceLoadUserList = useDebounce(loadFriendList, 500);

    useState(() => {
        loadFriendList();
    }, []);

    return (
        <div className='frame contact-frame'>
            <DialogModal showModal={showModal} setShowModal={setShowModal}>
                <h3>{showString}</h3>
            </DialogModal>

            <div className='contact-card'>
            <div className='contact-nav-menu'>
                <button className={actualList === 'contacts' ? "contact-nav-element-active" : 'contact-nav-element'} onClick={() => { setActualList('contacts'); loadFriendList(1, "", 'contacts'); }}>
                    Contactos
                </button>
                <button className={actualList === 'add-contacts' ? "contact-nav-element-active" : 'contact-nav-element'} onClick={() => { setActualList('add-contacts'); loadFriendList(1, "", 'add-contacts'); }}>
                    Agregar
                </button>
                <button className={actualList === 'friend-request-send' ? "contact-nav-element-active" : 'contact-nav-element'} onClick={() => { setActualList('friend-request-send'); loadFriendList(1, "", 'friend-request-send'); }}>
                    Solicitudes Enviadas
                </button>
                <button className={actualList === 'friend-request-received' ? "contact-nav-element-active" : 'contact-nav-element'} onClick={() => { setActualList('friend-request-received'); loadFriendList(1, "", 'friend-request-received'); }}>
                    Solicitudes Recibidas
                </button>
            </div>

            <div className='contact-search-bar'>
                <input type="text" className='contact-search-input' placeholder='Buscar...' onChange={(e) => debounceLoadUserList(null, e.target.value)} />
                <div className='contact-searchbar-controls'>
                    <p className='contact-pagin-indicator'>
                        Página {friendListPaging?.actual} de {friendListPaging?.total}
                    </p>
                    {(isPrevPage || isNextPage) &&
                        <div className='contact-content-elements-controls'>
                            <button className={isPrevPage ? 'contact-controls' : 'contact-controls-hidden'} onClick={() => handlerPaginate(-1)}>{'<'}</button>
                            <button className={isNextPage ? 'contact-controls' : 'contact-controls-hidden'} onClick={() => handlerPaginate(+1)}>{'>'}</button>
                        </div>
                    }
                </div>
            </div>

            <div className="contact-content-elements">
                {!onLoad && (
                    actualList === 'contacts' ? (
                        friendListData.length !== 0 ?
                            friendListData.map((item, index) => (
                                <div className='contact-content-element' key={index}>
                                    <div className='contact-info-container'>
                                        <img src={item.url_profile_pic || UserNotProfilePic} className='contact-img' />
                                        <h5 className='contact-name'>{item.name}</h5>
                                    </div>
                                    <button className='red-btn contact-btn' onClick={() => handlerDeleteFriend(item.id)}>Eliminar</button>
                                </div>
                            ))
                            : <div className='contact-empty-state'>No tenés contactos aún.</div>
                    ) : actualList === 'add-contacts' ? (
                        friendListData.length !== 0 ?
                            friendListData.map((item, index) => (
                                <div className='contact-content-element' key={index}>
                                    <div className="contact-info-container">
                                        <img src={item.url_profile_pic || UserNotProfilePic} className='contact-img' />
                                        <h5 className='contact-name'>{item.name}</h5>
                                    </div>
                                    <button className='green-btn contact-btn' onClick={() => handlerSendFriendRequest(item.id)}>Enviar Solicitud</button>
                                </div>
                            ))
                            : <div className='contact-empty-state'>No hay usuarios para agregar.</div>
                    ) : actualList === 'friend-request-send' ? (
                        friendListData.length !== 0 ?
                            friendListData.map((item, index) => (
                                <div className='contact-content-element' key={index}>
                                    <div className="contact-info-container">
                                        <img src={item.url_profile_pic || UserNotProfilePic} className='contact-img' />
                                        <h5 className='contact-name'>{item.name}</h5>
                                    </div>
                                    <span className='contact-btn-pending'>En espera</span>
                                    <button className='white-btn contact-btn' onClick={() => handlerDeleteFriend(item.id)}>Cancelar</button>
                                </div>
                            ))
                            : <div className='contact-empty-state'>No tenés solicitudes enviadas pendientes.</div>
                    ) : actualList === 'friend-request-received' ? (
                        friendListData.length !== 0 ?
                            friendListData.map((item, index) => (
                                <div className='contact-content-element' key={index}>
                                    <div className="contact-info-container">
                                        <img src={item.url_profile_pic || UserNotProfilePic} className='contact-img' />
                                        <h5 className='contact-name'>{item.name}</h5>
                                    </div>
                                    <button className='white-btn contact-btn' onClick={() => handlerDeleteFriend(item.id)}>Rechazar</button>
                                    <button className='green-btn contact-btn' onClick={() => handlerAcceptRequest(item.id_request)}>Aceptar</button>
                                </div>
                            ))
                            : <div className='contact-empty-state'>No tenés solicitudes recibidas pendientes.</div>
                    ) : null
                )}
            </div>
            </div>
        </div>
    );
}

export default Contactos;
